module.exports = __webpack_public_path__ + "/images/ico-check-green.3c0d78f.svg";